import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';

import { errorlogs } from '../config/errorlogs';
import { DataForAlertMessage } from '../../common/models/alertScreen';
import { Observable } from 'rxjs/Observable';
import { PaymentHistoryLog } from '../models/PaymentHistoryLog';
import { environment } from '../../../environments/environment';


@Injectable()
export class AppLoggingService {

  errorCode: string;
  isRegisterFailed: boolean;
  isPaymentFailed: boolean;

  constructor(private router: Router, private http: Http) {
    this.errorCode = '';
  }


  getErrorMessage(): DataForAlertMessage {
    const data = new DataForAlertMessage();
    // data.message = 'noe uventet har skjedd. vennligst kontakt oss på "hei@embla.no"';
    this.isRegisterFailed = false;
    this.isPaymentFailed = false;

    // Payment fail - type 1
    if (this.errorCode.charAt(4) === '4') {
      data.url = 'order';
      data.urlType = 1;
      data.message = 'En uforutsett feil har oppstått. Betalingen har feilet. Vennligst velg ' +
        'alternativet «Faktura i posten» eller ta kontakt med kundesupport. (feilkode:' + this.errorCode + ')';
      return data;
    }

    // Registration fail - type 2
    if (this.errorCode === "\"WSSE175\"") {
      data.url = 'register';
      data.urlType = 1;
      data.message = "En uforutsett feil har oppstått. Registreringen feilet. Vennligst fyll inn opplysningene dine en gang til. (feilkode:" + this.errorCode + ")";
      return data;
    }

    // Already paid
    if (this.errorCode === 'WSSE161') // WSSE161
    {
      data.url = environment.emblanoUrl;
      data.urlType = 2;
      data.message = "Allerede betalt. (feilkode:" + this.errorCode + ')';
      return data;
    }
    // Membership activation or provision fail
    if (this.errorCode.charAt(4) === '5') {

      data.url = environment.emblanoUrl + "/Content/AboutEmbla";
      data.urlType = 2;
      data.message = " Noe gikk galt. Betalingen er gjennomført, men en feil har oppstått. Vennligst ta kontakt med kundesupport. (feilkode:" + this.errorCode + ")";
      return data;
    }
  }

  AddPaymentTransactionLog(customerId, transactionId, orderId, amount, total, description,
    paymentMethod, statusId, isActive, email, promotionCode): Observable<any> {

    const paymentLog = new PaymentHistoryLog();

    paymentLog.customerId = customerId;
    paymentLog.transactionId = transactionId;
    paymentLog.orderId = orderId;
    paymentLog.amount = amount;
    paymentLog.total = total;
    paymentLog.description = description;
    paymentLog.paymentMethod = paymentMethod;
    paymentLog.statusId = statusId;
    paymentLog.isActive = isActive;
    paymentLog.email = email;
    paymentLog.promoCode = promotionCode;

    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    const options = new RequestOptions({ headers: headers, withCredentials: true });

    return this.http.post(environment.host + '/api/log/paymentTransactionLog', paymentLog, options)
      .map((response: any) => {

        const result = response.json();
        return result;
      });
  }

  UpdatePaymentTransactionLog(customerId, transactionId, orderId, amount, total, description, paymentMethod,
    statusId, isActive, email, promotionCode, invoiceNumber): Observable<any> {

    const paymentLog = new PaymentHistoryLog();

    paymentLog.customerId = customerId;
    paymentLog.transactionId = transactionId;
    paymentLog.orderId = orderId;
    paymentLog.amount = amount;
    paymentLog.total = total;
    paymentLog.description = description;
    paymentLog.paymentMethod = paymentMethod;
    paymentLog.statusId = statusId;
    paymentLog.isActive = isActive;
    paymentLog.email = email;
    paymentLog.promoCode = promotionCode;
    paymentLog.invoiceNumber = invoiceNumber;

    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    const options = new RequestOptions({ headers: headers, withCredentials: true });

    return this.http.post(environment.host + '/api/log/updatePaymentTransactionLog', paymentLog, options)
      .map((response: any) => {

        const result = response.json();
        return result;
      });
  }
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/common/services/AppLogging.service.ts